//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import CFooter from "@/common/Footer";

	export default {
		data() {
			return {
				username: '',
				CertState: '',
				money: '',
				yhq_count: '',
				productNum: [],
				userTile:'',
        msg_count:'0',
        product:{}
			}
		},
		mounted() {
			this.getInfo()
			this.getMessage()
		},
		components: {
			CFooter
		},
		computed: {

		},
		methods: {
      getMessage(){
        let data = 'cmd=user_msg_list&msg_type=0'
        this.$http.post('https://api.abeiyun.com/www/user.php', data).then(({data}) => {
          if(data.response == 200) {
            this.msg_count = data.msg.allcount
          }else {
            this.$router.push('/login')
          }
        })
      },
			getInfo() {
				let data = 'cmd=userinfo';
				this.$http.post('https://api.abeiyun.com/www/user.php', data).then(({
					data
				}) => {
					if(data.response == 200) {
            this.product = data.msg.product
						this.username = data.msg.cert_name || data.msg.ID_Mobile
            this.CertState = data.msg.cert_state
						this.money = data.msg.money;
						this.yhq_count = data.msg.yhq.onuse.length || '0';
						this.productNum = data.msg.product;
						if(data.msg.cName){
							this.userTile = data.msg.cName.substr(0,6)+'...';
						}else if(data.msg.ID_Mobile){
							this.userTile = data.msg.ID_Mobile.substr(0,11)
						}
					} else {
						this.$router.push('/login');
					}

				})
			},
      clickShiming() {
        this.$vux.toast.text('正在建设中...', 'middle')
      }

		}

	}



// WEBPACK FOOTER //
// ./src/components/Main.vue